// extracted by mini-css-extract-plugin
export var dateLabel = "_9x-0";
export var dateLabelError = "_9x-1";
export var fullWidth = "_9x-2";
export var smaller = "_9x-3";